import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-flashlight-line',
    tag: 'スピード重視',
    title: '買取',
    subtitle: '最短7日で現金化',
    desc: '仲介を通さず、当社が直接買い取ります。最短数日での現金化も可能。近所への告知なし、手続きもシンプルです。',
    points: ['最短数日で現金化', '仲介手数料なし', '秘密厳守', '現状のまま売却可'],
    cta: '無料で相談する',
    ctaHref: '/contact',
    external: false,
    image: 'https://public.readdy.ai/ai/img_res/94ab66378523535163f5903229b3ff10.jpg',
    accent: 'emerald',
  },
  {
    icon: 'ri-chat-smile-3-line',
    tag: 'まずは相談',
    title: '売却相談',
    subtitle: '無料・秘密厳守',
    desc: '「売るかどうかまだ決めていない」という段階でも大丈夫。状況を整理するだけでも、ぜひお気軽にご相談ください。',
    points: ['相談無料・秘密厳守', '売却時期の相談OK', '複数の選択肢を提示', '押し売り一切なし'],
    cta: '無料で相談する',
    ctaHref: '/contact',
    external: false,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20professional%20real%20estate%20consultant%20meeting%20with%20clients%20in%20bright%20modern%20office%2C%20warm%20friendly%20atmosphere%2C%20documents%20on%20table%2C%20natural%20light%2C%20trust%20and%20professionalism%2C%20clean%20interior%20design&width=600&height=400&seq=service_consult_v2&orientation=landscape',
    accent: 'slate',
  },
  {
    icon: 'ri-price-tag-3-line',
    tag: '高値重視',
    title: '仲介',
    subtitle: '市場価格で売却',
    desc: '市場に出して高値での売却を目指します。時間をかけてでも最大限の価格を引き出したい方に最適です。',
    points: ['市場価格での売却', '広告・内覧対応', '交渉サポート', '適切な手続き保証'],
    cta: 'サービス詳細を見る',
    ctaHref: '/services',
    external: false,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20Japanese%20residential%20property%20for%20sale%2C%20elegant%20traditional%20and%20modern%20fusion%20architecture%2C%20beautiful%20garden%2C%20premium%20neighborhood%2C%20golden%20hour%20lighting%2C%20high-end%20real%20estate%20photography&width=600&height=400&seq=service_agent_v2&orientation=landscape',
    accent: 'slate',
  },
];

export default function ServicesSection() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-12">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-px w-10 bg-emerald-500" />
            <span className="text-emerald-600 text-xs font-semibold tracking-[0.2em] uppercase">Services</span>
            <div className="h-px w-10 bg-emerald-500" />
          </div>
          <h2 className="text-[#1A2B4A] text-2xl md:text-4xl font-bold mb-4">サービスメニュー</h2>
          <p className="text-gray-500 text-sm max-w-md mx-auto">
            状況に合わせて、最適な方法をご提案します。
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className={`group rounded-2xl overflow-hidden border flex flex-col transition-all duration-300 hover:-translate-y-1 ${
                index === 0
                  ? 'border-emerald-200 ring-1 ring-emerald-100'
                  : 'border-gray-100'
              }`}
            >
              {/* Image */}
              <div className="relative h-44 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0D1B2E]/60 to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className={`text-xs font-semibold px-3 py-1.5 rounded-full ${
                    index === 0
                      ? 'bg-emerald-500 text-white'
                      : 'bg-white/20 text-white backdrop-blur-sm border border-white/30'
                  }`}>
                    {service.tag}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="text-white font-bold text-xl">{service.title}</div>
                  <div className="text-white/70 text-xs mt-0.5">{service.subtitle}</div>
                </div>
              </div>

              {/* Body */}
              <div className="p-6 flex flex-col flex-1 bg-white">
                <p className="text-gray-500 text-sm leading-relaxed mb-5">{service.desc}</p>
                <ul className="space-y-2 mb-6 flex-1">
                  {service.points.map((point, i) => (
                    <li key={i} className="flex items-center gap-2.5 text-sm text-gray-700">
                      <i className="ri-check-line text-emerald-500 flex-shrink-0" />
                      {point}
                    </li>
                  ))}
                </ul>
                {service.external ? (
                  <a
                    href={service.ctaHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block bg-emerald-500 hover:bg-emerald-600 text-white text-sm text-center py-3.5 px-6 rounded-xl font-semibold whitespace-nowrap transition-colors duration-200 cursor-pointer"
                  >
                    {service.cta}
                    <i className="ri-arrow-right-line ml-2" />
                  </a>
                ) : (
                  <Link
                    to={service.ctaHref}
                    className="block border border-[#1A2B4A] text-[#1A2B4A] text-sm text-center py-3.5 px-6 rounded-xl font-semibold whitespace-nowrap hover:bg-[#1A2B4A] hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {service.cta}
                    <i className="ri-arrow-right-line ml-2" />
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}